export default "<div class=\"footer\">\n\t<p class=\"symbol\"> © 2020 AVA Lifestyle Products & Services Pvt. Ltd. </p>\n</div>"